// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RevenueCalculator_wrapper__U01rn","results":"RevenueCalculator_results__biKck"};